module.exports = __webpack_public_path__ + "assets/img/remind-back.08c7caab.png";